import { useDispatch } from 'react-redux'

import { TOAST_TYPE } from '@base'
import { AddressDetailsCard } from '@baseV2'
import { DRAWER_TYPES, MBOOK_ORGANISATION_ID, strings } from '@constants'
import { getBillingAddressesApi, getUserAddressesApi, getWarehouseAddress } from '@data'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { LocalShippingOutlined, LocationOnOutlined, ReceiptOutlined, StoreOutlined } from '@material-ui/icons'

import { BillingGrid } from './styles'

// SPO Billing Details — the four address cards (dispatch / GST / mbook GST / shipping) via the
// common AddressDetailsCard. Payment Terms / Delivery Dates moved out to the two pages.
const BillingDetailsV2 = ({ state, valueChangeHandler }) => {
	const globalDispatch = useDispatch()
	const { newSpo, selectedUser } = state

	const renderDispatchLocation = () => {
		const address = state.newSpo?.dispatch_location
		const addDispatchLocation = (address) => valueChangeHandler('dispatch_location')(address)
		const addNewAddressHandler = () => {
			globalDispatch(
				toggleDrawer(true, DRAWER_TYPES.ADD_NEW_ADDRESS, {
					addCallback: (address) => {
						addDispatchLocation(address)
					},
					label: strings('add_new_address'),
				})
			)
		}
		const editDispatchLocation = () => {
			globalDispatch(showLoader(true))
			getUserAddressesApi(selectedUser?.user_id)
				.then((response) => {
					globalDispatch(
						toggleDrawer(true, DRAWER_TYPES.SELECT_ADDRESS_FROM_ADDRESSBOOK, {
							user: { ...state.selectedUser, addresses: response },
							label: strings('select_address'),
							selectedAddressId: address?.address_id,
							addToOrgCallback: addNewAddressHandler,
							updateCallback: addDispatchLocation,
							addToOrg: true,
						})
					)
				})
				.catch(() => {
					globalDispatch(showToast(true, strings('msg_could_not_fetch_user_addresses'), { type: TOAST_TYPE.ERROR }))
				})
				.finally(() => {
					globalDispatch(showLoader(false))
				})
		}

		return (
			<AddressDetailsCard
				title={strings('dispatch_location')}
				icon={LocationOnOutlined}
				onEdit={editDispatchLocation}
				addressData={address}
				isAddressSelected={!!address}
				showSelectAddressInHeader
			/>
		)
	}

	const renderGstDetails = () => {
		const address = newSpo?.billing_address?.address,
			gst = newSpo?.billing_address?.gst

		const updateBillingAddress = (_address) => {
			valueChangeHandler('billing_address')(_address)
		}

		const editBillingAddress = () => {
			globalDispatch(showLoader(true))
			getBillingAddressesApi(selectedUser?.organisation_id)
				.then((res) => {
					globalDispatch(
						toggleDrawer(true, DRAWER_TYPES.EDIT_GST_ADDRESS, {
							label: strings('edit', 'gst'),
							updateCallback: updateBillingAddress,
							addresses: res,
						})
					)
				})
				.catch(() => {
					globalDispatch(showToast(true, strings('msg_failed_to_fetch'), { type: TOAST_TYPE.ERROR }))
				})
				.finally(() => {
					globalDispatch(showLoader(false))
				})
		}

		return (
			<AddressDetailsCard
				title='GST Details'
				icon={ReceiptOutlined}
				onEdit={editBillingAddress}
				gst={gst}
				addressData={address}
				isAddressSelected={!!address}
				showSelectAddressInHeader
			/>
		)
	}

	const renderMbookBillingDetails = () => {
		const gst = newSpo?.mbook_billing_address?.gst,
			address = newSpo?.mbook_billing_address?.address,
			tradeName = newSpo?.mbook_billing_address?.trade_name

		const updateCallback = (_address) => {
			valueChangeHandler('mbook_billing_address')(_address)
		}
		
		const editMbookGst = () => {
			globalDispatch(
				toggleDrawer(true, DRAWER_TYPES.MBOOK_GST_SELECTION, {
					label: strings('edit', 'gst'),
					selectedAddressId: address?.address_id,
					submitCallback: updateCallback,
				})
			)
		}

		return (
			<AddressDetailsCard
				title={strings('mbook_gst')}
				icon={StoreOutlined}
				onEdit={editMbookGst}
				gst={gst}
				tradeName={tradeName}
				addressData={address}
				isAddressSelected={!!address}
				showSelectAddressInHeader
			/>
		)
	}

	const renderShippingDetails = () => {
		const address = newSpo?.shipping_address

		const editShippingAddress = () => {
			globalDispatch(showLoader(true))
			let consigneeList = []

			getWarehouseAddress(MBOOK_ORGANISATION_ID)
				.then((response) => {
					const modifiedResponse = response?.map((item) => {
						return {
							...item,
							organisation_id: item?.external_id,
							organisation_name: item?.warehouse_name,
							user_id: 'UpH5V1Rw7',
						}
					})
					consigneeList.push(...modifiedResponse)
					if (selectedUser) {
						consigneeList?.push(selectedUser)
					}
				})
				.catch(() => {})
				.finally(() => {
					globalDispatch(
						toggleDrawer(true, DRAWER_TYPES.EDIT_SPO_SHIPPING_ADDRESS, {
							label: 'Edit Shipping Address',
							state,
							valueChangeHandler,
							consigneeList,
						})
					)
					globalDispatch(showLoader(false))
				})
		}

		return (
			<AddressDetailsCard
				title={strings('shipping_address')}
				icon={LocalShippingOutlined}
				onEdit={editShippingAddress}
				addressData={address}
				isAddressSelected={!!address}
				showSelectAddressInHeader
			/>
		)
	}

	return (
		<BillingGrid>
			{renderDispatchLocation()}
			{renderGstDetails()}
			{renderMbookBillingDetails()}
			{renderShippingDetails()}
		</BillingGrid>
	)
}

export default BillingDetailsV2
